export default __webpack_public_path__ + "static/banner-two-shape2-79d60d7bc611f9ccbb88e9564cc3cc53.png";